import { FilterModel } from '../../filter/domain';

export const AssetMediaFilterKey = 'ASSET_MEDIA_FILTER';

export class AssetMediaFilterModel implements FilterModel {
  categoryId?: string;
  keyword?: string;

  constructor(data?: any) {
    this.categoryId = data?.categoryId;
    this.keyword = data?.keyword;
  }

  public getFilter(): any {
    return {
      keyword: this.keyword,
      categoryId: this.categoryId,
    };
  }
}
